/**
 * Replaces non-breaking space into a regular space.
 * Removes recurring spaces.
 * @param text to replace spaces in
 * @returns text with regular spaces
 */
export function normalizeString(text: string): string {
  return text.replace('\u00a0', ' ').replace(/\s\s+/g, ' ').trim();
}
